module.exports = __webpack_public_path__ + "img/hipscircumference.a24b64cd.jpeg";